import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React, {useState} from 'react';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {Collapsible} from '../../atoms/Collapsible/Collapsible';
import {Text} from '../../atoms/Text/Text';

interface StreamSeoTextProps {
  content: string;
  collapseOnClient: boolean;
}

export const StreamSeoText: React.FC<StreamSeoTextProps> = ({
  content,
  collapseOnClient,
}) => {
  const [label, setLabel] = useState<string | null>(null);
  const {t} = useTranslation();

  return (
    <Wrapper>
      <Collapsible
        openerContent={<Opener>{label}</Opener>}
        bodyContent={
          content && (
            <SeoHtmlTextContainer
              data-testid="AdditionalTextHTMLContainer"
              dangerouslySetInnerHTML={{
                __html: content,
              }}
            />
          )
        }
        minHeight={90}
        onChange={isOpen => setLabel(isOpen ? '' : t('More'))}
        startCollapsed={false}
        collapseOnClient={collapseOnClient}
      />
    </Wrapper>
  );
};

const Wrapper = styled.article`
  max-width: 100%;
  overflow: hidden;
  padding: 1.5rem;
  box-sizing: border-box;
`;

const Opener = styled(Text)`
  color: ${COLORS.Grey1};
  border-bottom: solid 1px ${COLORS.Grey1};
  cursor: pointer;
`;

const SeoHtmlTextContainer = styled.div`
  color: ${COLORS.Black};
  margin-bottom: ${FONT_SIZES.px32};

  > h1,
  > h2,
  > h3,
  > h4 {
    margin-top: ${FONT_SIZES.px32};
    margin-bottom: ${FONT_SIZES.px16};
  }
  > h1,
  > h2 {
    font-weight: ${FONT_WEIGHTS.bold};
  }

  > h2 {
    font-size: ${FONT_SIZES.px28};
  }

  > h3 {
    font-size: ${FONT_SIZES.px24};
    font-weight: ${FONT_WEIGHTS.bold};
  }

  > h4 {
    font-size: ${FONT_SIZES.px20};
    font-weight: ${FONT_WEIGHTS.bold};
  }

  li {
    font-size: ${FONT_SIZES.px12};
    line-height: 18px;
  }

  > ul {
    margin: 5px 0 10px;
    padding: 0;
    li {
      list-style-type: disc;
      font-size: ${FONT_SIZES.px12};

      ul {
        margin: 5px 0 10px 20px;
      }
    }
  }

  strong {
    font-size: ${FONT_SIZES.px12};
    font-weight: ${FONT_WEIGHTS.bold};
  }

  > p {
    font-size: ${FONT_SIZES.px12};
    font-weight: ${FONT_WEIGHTS.mediumBold};
    line-height: 18px;
    margin-bottom: ${FONT_SIZES.px24};
    color: ${COLORS.Black};
  }

  a {
    color: ${COLORS.Grey1} !important;
    text-decoration: underline;
  }

  img {
    padding: 24px 0;
  }
`;
